import PropTypes from 'prop-types';

import { PayIcon } from 'assets/icons';
import useCurrency from 'hooks/useCurrency';

import * as S from './styles';

/**
 * On the last step: that the booking takes a deposit paid online, and what it is, so that the payment page does not
 * come as a surprise. "Up to": the deposit is the company's amount or the services' total when that is less, which the
 * server settles when it takes the request. Until a service, a date and a time are picked there is nothing to price or
 * to hold, so it says what picks it up.
 */
const DepositNotice = ({ amount, isDue }) => {
  const { formatCurrency } = useCurrency();

  const hint = isDue
    ? 'You pay it online right after you press Submit and pay.'
    : 'Pick a service, a date and a time to book it and pay the deposit online when you submit.';

  return (
    <S.Notice role="status">
      <S.Icon><PayIcon aria-hidden="true" /></S.Icon>

      <div>
        <S.Title>{`Deposit to book: up to ${formatCurrency(amount)}`}</S.Title>

        <S.Hint>{hint}</S.Hint>
      </div>
    </S.Notice>
  );
};

DepositNotice.propTypes = {
  amount: PropTypes.number.isRequired,
  isDue: PropTypes.bool,
};

DepositNotice.defaultProps = {
  isDue: false,
};

export default DepositNotice;
